import computed from './computed'
import data from './data'
import components from './components'
import mounted from './mounted'

export default {
  computed,
  data,
  components,
  mounted,
  resourcePath: '/v1/dweller/parking/loan'
}



// WEBPACK FOOTER //
// ./src/app/dweller/parking/resources/index.js